<div class="form-group text-center">
    <input type='number' *ngFor="let c of formArray.controls" type="password" class="input-password shadow" appFormControl [formControl]="c" maxlength="1" size="1">
</div>